import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, nextTick, watch } from 'vue';
import { RailResponse } from '@/types/cms';
import { Language } from '@/enums/language';
import { useStore } from '@/composables/useStore';
import { useRailNavigation } from '@/composables/useRailNavigation';
import { CMSContinueWatchingManager } from '@/services/CMSContinueWatchingManager';
import HorizontalScroller from '@/components/containers/HorizontalScroller.vue';
import DynamicRailLoadingState from '@/components/rails/DynamicRailLoadingState.vue';
import TG4Button from '@/components/TG4Button.vue';
import { navigationService } from 'vue-spatialnavigation';
import GlyphView  from '@/components/glyphs/GlyphView.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContinueWatchingRail',
  props: {
    rail: null,
    railIndex: null,
    railDidNavigateDown: null
  },
  setup(__props: any) {

const props = __props as {
  rail: RailResponse;
  railIndex: number;
  railDidNavigateDown?: (railIndex: number) => void;
};






const { containerId, itemId, handleUp, handleDown, handleLeftFallback } = useRailNavigation(props);

const { useGetter } = useStore();
const currentLanguage = useGetter<string>('currentLanguage');

const localised = (en: string | null, ga: string | null) => {
  const value = currentLanguage.value === Language.Irish ? ga : en;
  return value ?? en ?? '';
};

const title = computed(() => localised(props.rail.titleEn, props.rail.titleGa));
const subtitle = computed(() => localised(props.rail.subtitleEn, props.rail.subtitleGa));

const railStyle = computed(() => ({
  'background-color': props.rail.backgroundColor ?? undefined,
  color: props.rail.textColor ?? undefined,
}));

const firstItemId = computed(() => itemId(0));



const hasItems = computed(() => (CMSContinueWatchingManager.videos.value?.length ?? 0) > 0);
const isLoading = computed(() => CMSContinueWatchingManager.state.value === 'loading');
const isError = computed(() => CMSContinueWatchingManager.state.value === 'error');

const load = () => CMSContinueWatchingManager.loadContinueWatchingRail();

onMounted(() => {
  //Manager is a singleton, so returning to home does not refetch
  if (CMSContinueWatchingManager.videos.value === undefined) load();
});

//Move focus to the first card when the state message it was on unmounts
watch(hasItems, async (nowHasItems) => {
  if (!nowHasItems) return;
  //Library's focus, not activeElement — it skips native focus when tabIndex is -1
  if (navigationService.getFocusElementInFocus()?.id !== firstItemId.value) return;

  await nextTick();
  // Small delay so v-focus has registered the newly inserted cell.
  setTimeout(() => {
    const focusElement = navigationService.getFocusElementById(firstItemId.value);
    focusElement?.focus();
    document.getElementById(firstItemId.value)?.focus();
  }, 100);
});

return { __sfc: true,props, containerId, itemId, handleUp, handleDown, handleLeftFallback, useGetter, currentLanguage, localised, title, subtitle, railStyle, firstItemId, hasItems, isLoading, isError, load, CMSContinueWatchingManager, HorizontalScroller, DynamicRailLoadingState, TG4Button, GlyphView }
}

})